<template>
    <div class="section row clearfix topmargin">
        <div v-if="loading">
            <b-spinner small></b-spinner>&nbsp;Loading pending change...
        </div>
        <div v-if="!loading && pendingDetails" class="leftmargin-sm rightmargin-sm" style="width: 100%">
            <h2>Pending Change Details</h2>

            <h4 style="margin: 0;">{{pendingDetails.request_type}}</h4>
            <div class="text-muted"><strong>Received:</strong> {{pendingDetails.date_recieved}}</div>
            <div class="text-muted"><strong>Effective Date:</strong> {{pendingDetails.effective_date}}</div>

            <hr class="mt-4">

            <div class="row mt-4">
                <div class="col-6">
                    <h3 class="">{{pendingDetails.change_requested.firstName}} {{pendingDetails.change_requested.lastName}}</h3>

                    <div v-if="pendingDetails.change_requested.homePhone">
                        <font-awesome-icon icon="phone"></font-awesome-icon> {{pendingDetails.change_requested.homePhone | phone}}<br>
                    </div>
                    <div v-if="pendingDetails.change_requested.workPhone">
                        <font-awesome-icon icon="building"></font-awesome-icon>{{pendingDetails.change_requested.workPhone | phone}}<br>
                    </div>

                    <div class="text-uppercase mt-3"><strong>Address</strong></div>
                    <div v-if="pendingDetails.change_requested.address !== ''">{{pendingDetails.change_requested.address}}<br></div>
                    <div v-if="pendingDetails.change_requested.address2 !== ''">{{pendingDetails.change_requested.address2}}<br></div>
                    <div v-if="pendingDetails.change_requested.city">{{pendingDetails.change_requested.city}}, {{pendingDetails.change_requested.stateName}} {{pendingDetails.change_requested.zipCode}}</div>

                    <table class="mt-4">
                        <tr>
                            <th width="150" class="text-uppercase">GENDER</th>
                            <td>{{pendingDetails.change_requested.gender}}</td>
                        </tr>
                        <tr>
                            <th width="150" class="text-uppercase">DATE OF BIRTH</th>
                            <td>{{pendingDetails.change_requested.dob}}</td>
                        </tr>
                        <tr>
                            <th width="150" class="text-uppercase">DATE HIRED</th>
                            <td>{{pendingDetails.change_requested.dateHired}}</td>
                        </tr>
                        <tr>
                            <th width="150" class="text-uppercase">HOURS WORKED</th>
                            <td>{{pendingDetails.change_requested.hoursWorked}}</td>
                        </tr>
                        <tr v-if="pendingDetails.change_requested.dhmoId">
                            <th width="150" class="text-uppercase">DHMO ID</th>
                            <td>{{pendingDetails.change_requested.dhmoId}}</td>
                        </tr>
                        <tr v-if="pendingDetails.change_requested.dhmoDept">
                            <th width="150" class="text-uppercase">DHMO Department</th>
                            <td>{{pendingDetails.change_requested.dhmoId}}</td>
                        </tr>
                        <tr v-if="pendingDetails.change_requested.otherCarrier">
                            <th width="150" class="text-uppercase">OTHER CARRIER</th>
                            <td>{{pendingDetails.change_requested.otherCarrier}}</td>
                        </tr>
                    </table>

                    <hr class="mt-4 mb-4">

                    <h4 class="text-uppercase">Dependents</h4>

                    <div v-for="d in pendingDetails.change_requested.children">
                        <h4 class="mb-1">{{d.firstName}} {{d.lastName}}</h4>

                        <table class="mt-2">
                            <tr>
                                <th width="150" class="text-uppercase">TYPE</th>
                                <td>{{d.type | capitalize}}</td>
                            </tr>
                            <tr>
                                <th width="150" class="text-uppercase">GENDER</th>
                                <td>{{d.gender | capitalize}}</td>
                            </tr>
                            <tr>
                                <th width="150" class="text-uppercase">DATE OF BIRTH</th>
                                <td>{{d.dob}}</td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="col-6">

                    <table class="mt-4">
                        <tr>
                            <th width="150" class="text-uppercase">Underwriter</th>
                            <td>{{pendingDetails.underwriter}}</td>
                        </tr>
                        <tr>
                            <th width="150" class="text-uppercase">Group</th>
                            <td>{{pendingDetails.group}}</td>
                        </tr>
                    </table>


                    <hr class="mt-3 mb-3">


                    <div>
                        <table class="mt-2">
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.DE)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="tooth" class="mr-1"/> Dental</th>
                                <td>{{pendingDetails.change_requested.planSelection.DE.plan}} / {{pendingDetails.change_requested.planSelection.DE.tier}}</td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.VI)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="eye" class="mr-1"/> Vision</th>
                                <td>{{pendingDetails.change_requested.planSelection.VI.plan}} / {{pendingDetails.change_requested.planSelection.VI.tier}}</td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.WI)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="hospital" class="mr-1"/> Short Term Disability</th>
                                <td>{{pendingDetails.change_requested.planSelection.WI.plan}} / {{pendingDetails.change_requested.planSelection.WI.tier}}</td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.LT)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="blind" class="mr-1"/> Long Term Disability</th>
                                <td>{{pendingDetails.change_requested.planSelection.LT.plan}} / {{pendingDetails.change_requested.planSelection.LT.tier}}</td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.LA)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="life-ring" class="mr-1"/> Basic Life</th>
                                <td></td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.VL)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="life-ring" class="mr-1"/> Voluntary Life</th>
                                <td></td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.VC)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="child" class="mr-1"/> Voluntary Child</th>
                                <td></td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.VD)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="user-friends" class="mr-1"/> Voluntary Dependent Life</th>
                                <td></td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.DL)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="users" class="mr-1"/> Dependent Life</th>
                                <td></td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.DI)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="hospital" class="mr-1"/> Disability</th>
                                <td></td>
                            </tr>
                            <tr v-if="!Array.isArray(pendingDetails.change_requested.planSelection.CI)">
                                <th width="250" class="text-uppercase"><font-awesome-icon fixed-width icon="user-injured" class="mr-1"/> Critical Illness</th>
                                <td></td>
                            </tr>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import config from '@/config/config'
    import axios from 'axios'

    export default {
        name: 'PendingDetails',
        props: ['id'],
        data () {
            return {
                loading: true,
            }
        },
        computed: {
            ...mapGetters(['pendingDetails']),
        },
        methods: {
            ...mapActions(['getPendingDetails']),
            // pending () {
            //     this.loading = false
            //     this.pendingActions.forEach(change => {
            //         if (change.cert) {
            //             axios.get(config.apiUrl() + 'member/' + change.cert).then(response => {
            //                 this.member.push(response.data)
            //             }, err => {
            //                 this.error = err.isNull
            //             })
            //         } else {
            //             let data = change.change_requested
            //             data.id = change.id
            //             data.group = change.group_code.substring(3)
            //             data.cert = 'Unassigned'
            //             data.request_type = change.request_type
            //             this.member.push(data)
            //         }
            //     })
            // }
        },
        beforeMount () {
            this.getPendingDetails(this.id);
        },
        watch: {
            pendingDetails (val) {
                if (val) {
                    val.request_type = titleCase(val.request_type.replace('_', ' '));
                    val.underwriter = val.group_code.substring(0,3);
                    val.group = val.group_code.substring(3);
                    this.loading = false;
                }
            }
        }
    }

    function titleCase(str) {
        str = str.toLowerCase().split(' ');
        for (let i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        return str.join(' ');
    }
</script>

<style scoped>

</style>
